import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import qs from 'query-string';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { actions } from 'userportal/ducks/auth';
import Alert from 'shared/components/Alert';
import Card from 'shared/components/Card';
import Divider from 'shared/components/Divider';
import Subheader from 'shared/components/Subheader';
import TranslateError from 'shared/components/TranslateError';
import Page from 'userportal/components/Page';
import Oauth from 'userportal/components/Oauth';
import { userportal as routes, backoffice, createBackofficeLink } from 'shared/routes';
import Form from 'shared/components/forms/Login';
import styles from './Login.module.scss';

const Login = () => {
  const dispatch = useDispatch();
  const error = useSelector(state => state.auth.error);
  const loggingIn = useSelector(state => state.auth.loggingIn);
  const { t } = useTranslation('userportal');
  const { as: loginAs } = qs.parse(location.search);
  const [isUser, setIsUser] = useState(!!error);

  useEffect(() => {
    if (loginAs === 'user') {
      setIsUser(true);
    }
  }, [loginAs]);

  const handleUserClick = (event) => {
    event.preventDefault();
    setIsUser(true);
  };

  const handleCompanyClick = () => {
    window.location.href = createBackofficeLink(backoffice.login);
  };

  return (
    <Page
      centered
      subheader={(
        <Subheader center title={t('page.login.title')}>
          <span>{t('page.login.subtitle', { name: t('common:name') })}</span>
        </Subheader>
      )}
      helmetTitle={t('page.login.title')}
    >
      {isUser ? (
        <div className="col-xl-4 col-lg-6 col-md-8 col-sm-8 col-xs-12">
          {error && <Alert variant="error"><TranslateError>{error}</TranslateError></Alert>}
          <Form onSubmit={(...args) => dispatch(actions.login(...args))} processing={loggingIn} />
          <Divider spacing="small">{t('page.login.or')}</Divider>
          <Oauth />
          <p className={styles.signup}>
            <Link to={routes.signup}>{t('page.login.createAccount')}</Link>
          </p>
          <p className={styles.signup}>
            <Link to={routes.resetPassword}>{t('common:passwordReset.link')}</Link>
          </p>
        </div>
      ) : (
        <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12">
          <h2 className="text-center mt32 mb32">
            {t('page.login.chooseTitle')}
          </h2>
          <div className={cn('row', styles.topCategories)}>
            <div className="col-lg-6 col-md-12">
              <Card noBorder className={styles.category} onClick={handleUserClick}>
                <i className="la la-user-tie" />
                <div>
                  <h3>
                    <Link to="./" onClick={handleUserClick} className={styles.user}>
                      {t('page.login.userTitle')}
                    </Link>
                  </h3>
                  <p>
                    {t('page.login.userText')}
                  </p>
                </div>
              </Card>
            </div>
            <div className="col-lg-6 col-md-12">
              <Card noBorder className={styles.category} onClick={handleCompanyClick}>
                <i className="la la-building" />
                <div>
                  <h3>
                    <a href={createBackofficeLink(backoffice.signup)} className={styles.client}>
                      {t('page.login.companyTitle')}
                    </a>
                  </h3>
                  <p>
                    {t('page.login.companyText')}
                  </p>
                </div>
              </Card>
            </div>
          </div>
        </div>
      )}
    </Page>
  );
};

export default Login;
